"use strict";
/*
 * Created on 27.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Class which holds information about user session.
 *
 * @author MSu
 */


var SessionInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SessionInfo, _DomainObject_1$Domai);

  /**
   * @param id session ID
   * @param userId user ID, owner of session
   * @param entityId main entity ID, object of session
   * @param lastSimulationLoad time of last load of simulation
   * @param flags
   * @param created
   */
  function SessionInfo(id, userId, entityId, lastSimulationLoad, flags, created) {
    var _this;

    _classCallCheck(this, SessionInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SessionInfo).call(this));
    _this.id = id;
    _this.userId = userId;
    _this.entityId = entityId;
    _this.lastSimulationLoad = lastSimulationLoad;
    _this.flags = flags;
    _this.created = created;
    return _this;
  }

  return SessionInfo;
}(DomainObject_1.DomainObject);

exports.SessionInfo = SessionInfo;